// extracted by mini-css-extract-plugin
export default {"footer":"footer---S_X5S","validationError":"validationError---nXxFi"};